
import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { MessageSenderListQuery, MessageTemplateListQuery, RequisiteTypeListQuery } from '../core/query.types'
import { ApiResponse } from '../../../../../common/api/response.types'
import { IBaseMessageElement, IMessageGenerateTemplateResp, IMessageMatchTemplateResp, IMessageSender, IMessageSenderLookup, IMessageTemplate, IRequisiteType } from './response.types'
import { IMessageGenerateTemplateBody, IMessageMatchTemplateBody, IMessageTemplateCreateBody } from './requests.types'

// ==================== RequisiteType ====================

export const getRequisiteTypeList = (params: RequisiteTypeListQuery) => {
  return axios.get<ApiResponse<IRequisiteType[]>>(`${API_URL}/api/internal/requisite-type`, { params })
}

// ==================== Senders ====================

export const getMessageSenderLookupList = () => {
  return axios.get<ApiResponse<IMessageSenderLookup[]>>(`${API_URL}/api/sms/message-sender/lookup`)
}

export const getMessageSenderList = (params: MessageSenderListQuery) => {
  return axios.get<ApiResponse<IMessageSender[]>>(`${API_URL}/api/sms/message-sender`, { params })
}

export const newMessageSender = (data: {}) => {
  return axios.post<ApiResponse<IMessageSender>>(`${API_URL}/api/sms/message-sender`, data)
}

export const toggleEnableMessageSender = (id: number) => {
  return axios.patch<ApiResponse<IBaseMessageElement>>(`${API_URL}/api/sms/message-sender/${id}/toggle-enable`)
}

// ==================== Templates ====================

export const getMessageTemplateList = (params: MessageTemplateListQuery) => {
  return axios.get<ApiResponse<IMessageTemplate[]>>(`${API_URL}/api/sms/message-template?operation[]=DEPOSIT`, { params })
}

export const messageMatchTemplate = (data: IMessageMatchTemplateBody) => {
  return axios.post<ApiResponse<IMessageMatchTemplateResp>>(`${API_URL}/api/sms/message-template/match`, data)
}

export const generateTemplate = (data: IMessageGenerateTemplateBody) => {
  return axios.post<ApiResponse<IMessageGenerateTemplateResp>>(`${API_URL}/api/sms/message-template/generate`, data)
}

export const saveTemplate = (data: IMessageTemplateCreateBody) => {
  return axios.post<ApiResponse<IMessageTemplate>>(`${API_URL}/api/sms/message-template`, data)
}
